import { Stat, money } from "@/components/finance/fin";

const pct = (v) => (v == null ? "—" : `${v}%`);

export function BudgetStats({ sum }) {
  if (!sum) return null;
  const dedSub = sum.tax_method === "none" ? "Amounts entered as take-home" : `Gross ${money(sum.gross_income, 0)} − est. ${money(sum.estimated_deductions, 0)} (${sum.deduction_rate_pct}%)`;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3" data-testid="budget-results">
      <Stat label="Take-home income" value={money(sum.total_income)} testId="budget-total-income" sub={dedSub} />
      <Stat label="Monthly expenses" value={money(sum.total_expenses)} testId="budget-total-expenses" />
      <Stat label="Disposable income" value={money(sum.disposable)} tone={sum.disposable >= 0 ? "good" : "bad"} testId="budget-disposable" />
      <Stat label="Monthly savings" value={money(sum.monthly_savings)} testId="budget-savings" />
      <Stat label="Debt-to-income" value={pct(sum.debt_to_income_pct)} tone={sum.debt_to_income_pct > 44 ? "bad" : undefined} testId="budget-dti" sub="Housing + debt payments ÷ gross" />
      <Stat label="Income spent" value={pct(sum.spending_pct)} tone={sum.spending_pct > 100 ? "bad" : undefined} testId="budget-spending-pct" sub="Expenses ÷ take-home" />
      <Stat label="Savings rate" value={pct(sum.savings_pct)} tone={sum.savings_pct >= 10 ? "good" : undefined} testId="budget-savings-pct" sub="Savings ÷ take-home" />
    </div>
  );
}
